import(/* webpackMode: "eager", webpackExports: ["ContactUsPage"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/components/landing/contact-us/ContactUsPage.tsx");
